const DEFAULT_SESSION = {
  time: '- - -',
  note: '-',
  location: '-',
  images: [],
};

const getReportAttendanceHostDetailResponse = (response, t) => {
  let maxSessionCount = 0;

  const reports = response?.data?.data.map((report) => {
    const hostPresence = report?.hostPresence;
    const sessions = report?.streamingSessions || [];

    if (sessions.length > maxSessionCount) maxSessionCount = sessions.length;

    const sessionData = sessions.reduce((acc, session, index) => {
      if (session?.clockIn?.selfieImageUrl && session?.clockIn?.locationImageUrl) {
        session.images = [
          { url: session?.clockIn?.selfieImageUrl, caption: `${t('photo.selfie')} - ${t('photo.startLivestream')}` },
          { url: session?.clockIn?.locationImageUrl, caption: `${t('photo.environment')} - ${t('photo.startLivestream')}` },
        ];
      }

      if (session?.clockOut?.selfieImageUrl && session?.clockOut?.locationImageUrl) {
        session.images = [
          ...(session.images || []),
          { url: session?.clockOut?.selfieImageUrl, caption: `${t('photo.selfie')} - ${t('photo.endLivestream')}` },
          { url: session?.clockOut?.locationImageUrl, caption: `${t('photo.environment')} - ${t('photo.endLivestream')}` },
        ];
      }

      acc[`session_${index}`] = {
        startLive: { time: session?.clockIn?.time || '-', status: session?.clockIn?.timeStatus },
        endTime: session?.clockOut?.time || '-',
        startNote: session?.clockIn?.note || '-',
        endNote: session?.clockOut?.note || '-',
        location: session?.clockIn?.location || '-',
        images: session?.images || [],
      };
      return acc;
    }, {});

    for (let i = 0; i < 3; i++) {
      sessionData[`session_${i}`] = sessionData[`session_${i}`] || DEFAULT_SESSION;
    }

    const clockoutData = {
      time: hostPresence?.clockOut?.time || '-',
      note: hostPresence?.clockOut?.note || '-',
      location: hostPresence?.clockOut?.location || '-',
      images: [
        { url: hostPresence?.clockOut?.selfieImageUrl, caption: `${t('photo.selfie')} - ${t('photo.clockOut')}` },
        { url: hostPresence?.clockOut?.locationImageUrl, caption: `${t('photo.environment')} - ${t('photo.clockOut')}` },
      ].filter(Boolean),
      timeStatus: hostPresence?.clockOut?.timeStatus || '-',
      locationStatus: hostPresence?.clockOut?.locationStatus || '-',
    };

    return {
      shiftDate: hostPresence?.workDate || '-',
      clockIn: {
        time: hostPresence?.clockIn?.time || '-',
        note: hostPresence?.clockIn?.note || '-',
        location: hostPresence?.clockIn?.location || '-',
        images: [
          { url: hostPresence?.clockIn?.selfieImageUrl, caption: `${t('photo.selfie')} - ${t('photo.clockIn')}` },
          { url: hostPresence?.clockIn?.locationImageUrl, caption: `${t('photo.environment')} - ${t('photo.clockIn')}` },
        ].filter(Boolean),
        timeStatus: hostPresence?.clockIn?.timeStatus || '-',
        locationStatus: hostPresence?.clockIn?.locationStatus || '-',
      },
      clockOut: hostPresence?.duration || hostPresence?.clockOut?.timeStatus === 'Belum Clock Out' ? clockoutData : null,
      ...sessionData,
    };
  });

  return { ...response.data, reports, maxSessionCount };
};

export default getReportAttendanceHostDetailResponse;
